import React, { useContext, useEffect } from 'react';
import { telegramLogin } from '../../../stores/auth.store';
import { ISuccessfulAuth, TelegramUserData } from '../../../interfaces';
import { LOGIN_BY_TELEGRAM_ERROR } from '../../../common/errorCodes';
import { MainContext } from '../../../context/main.context';
import ManualController from '../../../hoc/ManualController';


export default function TelegramAuth() {
    const { toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();

    useEffect(() => {
        const _messageListener = (event: MessageEvent<any>) => {
            const { data, origin } = event;

            console.log('[ TELEGRAM_AUTH ] получил сообщение:', { data, origin });

            if (origin !== 'https://oauth.telegram.org') {
                return;
            }

            if (data) {
                const { event, auth_data } = JSON.parse(data);

                if (event !== 'auth_user') {
                    return;
                }

                if (!auth_data) {
                    console.error('TELEGRAM_AUTH_DATA_NOT_FOUND', { event });
                    return;
                }

                const userData: TelegramUserData = {
                    id: auth_data?.id,
                    first_name: auth_data?.first_name,
                    last_name: auth_data?.last_name,
                    username: auth_data?.username,
                    photo_url: auth_data?.photo_url,
                }

                _telegramLogin(userData);
            }

            console.error('TELEGRAM_DATA_NOT_FOUND', { event });
        }

        window.onTelegramAuth = (user: any) => {
            console.log('Telegram user onTelegramAuth:', { user });
        };

        window.addEventListener('message', _messageListener);

        const botName: string = process.env.REACT_APP_TELEGRAM_CLIENT_BOT_NAME as string;

        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?22';
        script.async = true;
        script.setAttribute('data-telegram-login', botName);
        script.setAttribute('data-size', 'large');
        script.setAttribute('data-onauth', 'onTelegramAuth');
        script.setAttribute('data-userpic', 'false');
        script.setAttribute('data-radius', '10');
        script.setAttribute('data-request-access', 'write');

        const parent = document.getElementById('tg-id');

        if (parent) {
            parent.appendChild(script);
        }

        return () => {
            if (parent) {
                parent.removeChild(script);
            }

            window.removeEventListener('message', _messageListener);
        };
    }, []);

    const _telegramLogin = (userData: TelegramUserData): void => {
        toggleLoader(true);

        telegramLogin(userData).then((res: { data: ISuccessfulAuth }) => {
            const result = res?.data?.result;

            if (result) {
                manualRedirect(result, 'auth');
                return;
            }

            manualRedirect(res, 'auth', true, LOGIN_BY_TELEGRAM_ERROR);
        }, err => {
            const errData = err?.response?.data || err;

            manualRedirect(errData, 'auth', true, LOGIN_BY_TELEGRAM_ERROR);
        }).finally(() => {
            toggleLoader(false);
        });
    }

    return (
        <div id="tg-id" className="auth-modal-menu-body-button-tg"></div>
    );
}
